<template>
  <div class="open-layout">
    <header class="layout-header">
      <div class="logo-container" @click="toLogin">
        <img class="logo" src="/logo-2.png" alt="Logo">
      </div>
    </header>

    <main class="layout-body">
      <router-view></router-view>
    </main>

    <footer class="layout-footer">
      <span>© {{ currentYear }}. FabricaInfo</span>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'OpenLayout',
  components: {},
  methods: {
    toLogin() {
      this.$router.push({ name: 'login' })
    }
  },
  computed: {
    currentYear() {
      return (new Date()).getFullYear()
    },
  },
}
</script>

<style lang="scss">
.open-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .layout-header {
    height: 4.375rem;
    padding: 1.25rem 3.125rem;
    background: #1C2D5A;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-container {
      cursor: pointer;
    }
  }

  .layout-body {
    flex: 1;
    padding: 0 1.25rem;
  }

  .layout-footer {
    padding: 1rem 0;
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: 600;
  }
}
</style>
